import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Treasure from '../game/Treasure';
import gameData from '../gameData';
import Level1 from '../scenes/Level1';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Popup from './Popup';
import ABCyaLib from '@abcya/abcya_lib';

export default class NavBar extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Level1} scene 
   */
  constructor(scene) {
    super(scene);
    this.scene = scene;

    this.menu = null;
    this.chest = null;
    this.popup = null;

    this.setup();
  }

  setup () {
    this.createButtons();
    this.createBar();
    this.createTitle();

    this.tweenInNav();
  }

  createButtons () {
    this.menu = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._HomeBtn, this.scene);
    this.menu.setPosition(-this.menu.width / 2, 70);
  }

  createBar() {
    this.progressBar = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._ProgBar, this);

    this.chest = new Treasure(this.scene);
    this.chest.y = this.progressBar.height / 2 + 25;
    this.add(this.chest);

    let subY = -this.progressBar.height / 2;
    if (gameData.config.level === 1) {
      subY = -this.progressBar.height / 2;
    }
    else if (gameData.config.level === 2) {
      subY = -this.progressBar.height / 4 - 20;
    }
    else if (gameData.config.level === 3) {
      subY = -20;
    }
    else if (gameData.config.level === 4) {
      subY = 80;
    }
    this.sub = ABCyaPhaser.Images.addImage(-7, subY, UIAssetKeys._pSub, this);

    this.setPosition(this.scene.scale.width + this.progressBar.width / 2, this.scene.scale.height / 2);
  }

  createTitle() {
    const frame = gameData.config.gameMode < 6 ? `LvlBtn${gameData.config.gameMode}` : UIAssetKeys._1_Welcome_and_Level_Screen_LvlBtn6;
    const atlas = gameData.config.gameMode < 6 ? ABCyaPhaser.Images.LOCALIZATION_ATLAS : ABCyaPhaser.Images.DEFAULT_ATLAS;
    this.title = ABCyaPhaser.Images.addImage(0, 0, frame, this.scene, atlas);
    this.title.setPosition(this.scene.scale.width + this.title.width / 2, 70);

    // hide the title image when in a variant
    this.title.setVisible(ABCyaLib.Environment.instance.gameConfig.gameMode === null);
  }

  tweenInNav () {
    ABCyaPhaser.Tweens.addTween(this.menu, 2500, { x: this.menu.width / 2 + 10 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this, 2500, { x: this.scene.scale.width - this.progressBar.width / 2 - 20 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.title, 2500, { x: this.scene.scale.width - this.title.width / 2 - 5 }, Phaser.Math.Easing.Back.Out, () => {
      this.enableButtons();
    });
  }

  enableButtons () {
    this.menu.setInteractive({ useHandCursor: true });
    this.menu.removeListener(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
    this.menu.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.pauseGame, this);
  }

  disableButtons () {
    this.menu.disableInteractive();
  }

  pauseGame () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.popup = new Popup(this.scene, this);

    this.scene.pauseGame();
    this.disableButtons();
  }

  resumeGame () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.enableButtons();

    this.popup.cleanUp();
    this.popup.destroy();

    this.scene.resumeGame();
  }

  goHome () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.scene.goHome();
  }

  moveSub () {
    ABCyaPhaser.Tweens.addTween(this.sub, 2000, { y: this.sub.y + 26 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.sub, 333, { angle: -2 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.sub, 333, { angle: 0, delay: 333 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.sub, 333, { angle: 2, delay: 666 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.sub, 333, { angle: 0, delay: 999 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.sub, 333, { angle: -2, delay: 1332 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.sub, 333, { angle: 0, delay: 1665 }, Phaser.Math.Easing.Linear);
  }

  tweenOutNav () {
    ABCyaPhaser.Tweens.addTween(this.menu, 2000, { x: -this.menu.width / 2 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this, 2000, { x: this.scene.scale.width + this.progressBar.width / 2 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.title, 2000, { x: this.scene.scale.width + this.title.width / 2 }, Phaser.Math.Easing.Back.Out);
  }

  cleanUp () {
    gameData.config.gamePaused = false;

    this.disableButtons();

    if (this.popup) {
      this.popup.cleanUp();
      this.popup.destroy();
    }

    if (this.menu) this.menu.destroy();
  }
}